import { render, staticRenderFns } from "./Pharmacy.vue?vue&type=template&id=7b570e49"
import script from "./Pharmacy.vue?vue&type=script&lang=js"
export * from "./Pharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports